export function getTypesArray(currentItems) {
  let currentTypes = [];

  for (let currentItem of currentItems) {
    currentTypes = [...currentTypes, currentItem.type];
  }

  return currentTypes;
}
